import { render } from "./ReportPPE.vue?vue&type=template&id=e458e06e"
import script from "./ReportPPE.vue?vue&type=script&lang=js"
export * from "./ReportPPE.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportPPE.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e458e06e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e458e06e', __exports__)) {
    console.log('reload')
    api.reload('e458e06e', __exports__)
  }
  
  module.hot.accept("./ReportPPE.vue?vue&type=template&id=e458e06e", () => {
    console.log('re-render')
    api.rerender('e458e06e', render)
  })

}


export default __exports__